export enum TransactionType {
  Buy = 'Buy',
  Sell = 'Sell',
  Drip = 'Drip',
  Bonus = 'Bonus',
}

export enum DividendType {
  Drip = 'Drip',
  Cash = 'Cash',
}
